<template>
  <section class="content-block">
    <div
      class="mx-auto max-w-(--breakpoint-lg) py-16 px-6 sm:py-16 sm:px-16 section-background rounded-3xl"
    >
      <div class="flex items-center justify-center mb-5">
        <img
          class="club-member"
          src="/images/misc/cyclist.webp"
          alt="cyclist"
          width="1000"
          height="1000"
        />
        <img
          class="club-member -mx-4"
          src="/images/misc/runner.webp"
          alt="runner"
          width="1000"
          height="1000"
        />
        <img
          class="club-member relative"
          src="/images/misc/hiker.webp"
          alt="hiker"
          width="1000"
          height="1000"
        />
      </div>
      <div class="flex flex-col justify-center items-center text-center">
        <h2 class="section-title">Join our Strava Club</h2>
        <p class="section-subtitle mb-10!">
          Join our Fitsnack Club on Strava and burn snacks together!
        </p>

        <div class="flex flex-wrap justify-center md:justify-start items-center gap-5">
          <join-the-club-button></join-the-club-button>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import JoinTheClubButton from '@/components/JoinTheClubButton.vue'
</script>

<style scoped>
@reference "../../../assets/css/base.css";

.club-member {
  @apply size-16  rounded-full border-4 border-gray-25;
}
</style>
